module.exports = __webpack_public_path__ + "img/left-link-banner-en.e20ac702.png";